import { keepPreviousData, useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiAnalysisFunnelsShow } from '@/types/serializers';

// ファネルAPIのクエリパラメータ型
export interface FunnelQueryParams {
  from: string;
  to: string;
  granularity: 'day' | 'week' | 'month';
  metric: 'uu' | 'count';
  count_mode: 'total' | 'registered_cohort';
  group_by?: 'candidate_user' | 'company_user' | 'job_user' | 'company';
  filter_organization_user_ids?: number[];
  filter_target: 'candidate' | 'company';
  filter_company_tag_ids?: number[];
  filter_job_tag_ids?: number[];
  filter_candidate_tag_ids?: number[];
  visible_steps?: string[];
  page: number;
  per_page?: number;
}

/**
 * 分析ファネルデータを取得するカスタムフック
 * TanStack Query を使用してキャッシュ管理を行う
 */
export default function useFetchAnalysisFunnel(params: FunnelQueryParams) {
  const query = qs.stringify(params, { arrayFormat: 'brackets' });

  return useQuery<AgentApiAnalysisFunnelsShow>({
    queryKey: ['/agent/api/analysis/funnel', query],
    queryFn: async () => {
      const response = await fetch(`/agent/api/analysis/funnel.json?${query}`);
      if (!response.ok) {
        throw new Error('分析データの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiAnalysisFunnelsShow>;
    },
    // ページ移動などのパラメータ変更時、新データ取得中も前データを保持する
    // → 全画面ローディングではなくテーブル内のオーバーレイで表示できる
    placeholderData: keepPreviousData,
  });
}
